export default {"src":"/_next/static/media/academy.8bc2df27.svg","height":17,"width":23};